class Controller {
  constructor(
    $injector,
    $scope,
    $timeout,
    $mdDialog,
    customer,
    callState,
    Events,
    PureCloud
  ) {
    "ngInject";
    this.$mdDialog = $mdDialog;
    this.Events = Events;
    this.customer = customer;
    this.callState = callState;
    this.scope = $scope;
    this.timeout = $timeout;
    this.pureCloud = PureCloud;
    this.endCallEvent = this.Events.endCallEvent("endCall");
    this.startWatchEvent = this.Events.startWatchEvent("startWatch");
    this.clearWatchEvent = this.Events.clearWatchEvent("clearEvent");
  }

  $onInit() {
    this.Events.on(this.endCallEvent, this.close.bind(this));
    this.watch = new this.StopWatch(
      this.Events,
      this.startWatchEvent,
      this.clearWatchEvent
    );

    this.scope.$watch(
      () => {
        this.timeout();
        return this.pureCloud.callState;
      },
      (oldVal, newVal) => {
        if (oldVal === "terminated" && newVal === "terminated") {
          this.callState = "contacting";
        } else if (oldVal === "disconnected" && newVal === "disconnected") {
          this.callState = "contacting";
        } else if (oldVal === "disconnected" || oldVal === "terminated") {
          this.callState = oldVal;
          this.close();
        } else {
          this.callState = oldVal === "disconnected" ? newVal : oldVal;
        }
        if (this.callState === "connected") {
          this.watch.start();
        }
      }
    );
  }

  close() {
    this.$mdDialog.cancel();
    this.watch.clear();
  }

  StopWatch(events, startEvent, clearEvent) {
    this.start = () => events.emit(startEvent);
    this.clear = () => events.emit(clearEvent);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/customer/callDialog/callDialog.controller.js